// TransFi 支付方式目录（前端镜像，数据源 = 后端 TransfiPaymentMethodCatalog / docs payment-methods 实测）
// 仅用于金丝雀测试平台 TransFi 表单：按 币种+方向 给出正确的 depositMethod/withdrawMethod 选项、
// bankCode 选项（payin 小清单枚举，payout 银行数量极多保持自由输入）。
// 金额上下限不在前端校验，完全交后端兜底（TransfiPaymentMethodValidator + 测试平台安全服务）。
// 只影响 TRANSFI 渠道，其它渠道不读取本模块。

// currency -> { bank: [bankCode 大写...], wallet: [wallet 编码大写...] }
const PAYIN = {
  GHS: { wallet: ['AIRTEL', 'MTN', 'VODAFONE'] },
  IDR: { bank: ['BCA', 'BNI', 'BRI', 'BSI', 'CIMB', 'DANAMON', 'MANDIRI', 'PERMATA'], wallet: ['DANA', 'OVO', 'QRIS', 'SHOPEEPAY'] },
  KES: { wallet: ['AIRTEL', 'MPESA'] },
  PHP: { bank: ['BDO', 'BPI', 'LANDBANK', 'METROBANK', 'UBP'], wallet: ['GCASH', 'PH_GRABPAY', 'PH_PAYMAYA', 'QRPH', 'PH_SHOPEE'] },
  TZS: { wallet: ['AIRTEL', 'HALO_PESA', 'TIGO_PESA'] },
  UGX: { wallet: ['AIRTEL', 'MTN'] },
  VND: { bank: ['ACB', 'BIDV', 'MB', 'MSB', 'SHB', 'SACOMBANK', 'TECHCOM_BANK', 'VPB', 'VTB', 'VIETCOMBANK'], wallet: ['MOMO', 'VIETQR', 'VIETTEL_PAY', 'ZALO'] },
  XOF: { wallet: ['MTN', 'MOOV', 'ORANGE', 'WAVE'] },
  ZMW: { wallet: ['AIRTEL', 'MTN'] },
};

const PAYOUT = {
  GHS: { wallet: ['AIRTEL', 'MTN', 'VODAFONE'] },
  // payout bank_transfer 银行数量极多（IDR 185/PHP 108/VND 80 家），bankCode 保持自由输入，由后端白名单精确校验
  IDR: { bank: true, wallet: ['DANA', 'GOPAY', 'LINKAJA', 'OVO', 'SHOPEEPAY'] },
  KES: { wallet: ['AIRTEL', 'MPESA'] },
  PHP: { bank: true, wallet: ['GCASH', 'PH_GRABPAY', 'PH_PAYMAYA', 'PH_SHOPEE'] },
  TZS: { wallet: ['AIRTEL', 'HALO_PESA', 'TIGO_PESA', 'VODACOM_MPESA'] },
  UGX: { wallet: ['AIRTEL', 'MTN'] },
  VND: { bank: true, wallet: ['MOMO', 'VIETTEL_PAY', 'VIETTEL_MONEY', 'ZALO_PAY'] },
  XOF: { wallet: ['MTN', 'MOOV', 'ORANGE', 'WAVE'] },
  ZMW: { wallet: ['AIRTEL', 'MTN'] },
};

const CRYPTO_ONRAMP = 'CRYPTO_ONRAMP';
const CRYPTO_OFFRAMP = 'CRYPTO_OFFRAMP';

// 返回某币种某方向的 depositMethod/withdrawMethod 下拉可选值（大写）：BANK_TRANSFER(若支持) + 钱包编码 + CRYPTO_ONRAMP/OFFRAMP
export function transfiMethodOptions(currency, direction) {
  const table = direction === 'withdraw' ? PAYOUT : PAYIN;
  const cfg = currency ? table[currency] : null;
  const opts = [];
  if (cfg) {
    if (cfg.bank) opts.push('BANK_TRANSFER');
    (cfg.wallet || []).forEach(w => opts.push(w));
  }
  opts.push(direction === 'withdraw' ? CRYPTO_OFFRAMP : CRYPTO_ONRAMP);
  return opts;
}

// payin bankCode 枚举（小清单）；payout 返回 null（银行众多，保持自由输入）
export function transfiBankCodeOptions(currency, direction) {
  const table = direction === 'withdraw' ? PAYOUT : PAYIN;
  const cfg = currency ? table[currency] : null;
  if (!cfg) return null;
  return Array.isArray(cfg.bank) ? cfg.bank : null;
}

export const TRANSFI_CRYPTO_ONRAMP = CRYPTO_ONRAMP;
export const TRANSFI_CRYPTO_OFFRAMP = CRYPTO_OFFRAMP;
